import axios from '@/utils/http'

/**
 *
 * 获取菜品下拉列表
 * @export
 * @param {*} params
 * @returns
 */
export function getMenuList(params) {
  return axios({
    url: '/MenuService/MenuManage/GetMenuList',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 获取发布菜品列表
 * @export
 * @param {*} params
 * @returns
 */
export function getPublishMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/GetPublicMenu',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 一键发布菜品
 * @export
 * @param {*} params
 * @returns
 */
export function onekeyPublishMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/OnekeyPublicMenu',
    headers: {
      'Content-type': 'application/json'
    },
    method: 'post',
    data: params
  })
}

/**
 *
 * 发布菜品
 * @export
 * @param {*} params
 * @returns
 */
export function addPublishMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/AddPublicMenu',
    headers: {
      'Content-type': 'application/json'
    },
    method: 'post',
    data: params
  })
}

/**
 *
 * 发布菜品检测
 * @export
 * @param {*} params
 * @returns
 */
export function publishMenuTest(params) {
  return axios({
    url: '/MenuService/MenuManage/MenuRecommendTesting',
    method: 'get',
    params: {
      ...params
    }
  })
}

/**
 *
 * 修改发布菜品
 * @export
 * @param {*} params
 * @returns
 */
export function editPublishMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/EditPublicMenu',
    method: 'post',
    data: params
  })
}

/**
 *
 * 删除发布菜品
 * @export
 * @param {*} params
 * @returns
 */
export function delPublishMenu(params) {
  return axios({
    url: '/MenuService/MenuManage/RemovePublicMenu',
    method: 'post',
    data: params
  })
}

/**
 *
 * 获取菜品下拉列表
 * @export
 * @param {*} params
 * @returns
 */
export function getMenuPublishState(params) {
  return axios({
    url: '/MenuService/MenuManage/GetIsPublishMenu',
    method: 'get',
    params: {
      ...params
    }
  })
}
